import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/device/page', data, {
    trim: true
  })
}

// 同步
export function syncDevices (data) {
  return request.post('/business/hksync/syncDevices', data)
}

// 获取门禁集合-提供给门禁组
export function getList (data) {
  return request.post('/business/device/getList', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/device/updateById', data)
}
